import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Swipe from 'react-easy-swipe';

import { closeNavbar } from '../Actions/Navigation';

import './Navigation.scss';

class Navigation extends Component {
  compoentWillMount() {}

  componentWillUpdate() {}

  render() {
    const collapseNavbarClass = this.props.collapsedNavbar
      ? 'collapse navbar-collapse'
      : 'collapse navbar-collapse show';

    return (
      <Swipe onSwipeMove={this.props.closeNavbar}>
        <div className={collapseNavbarClass} id="navbar-collapse">
          <div className="sm-visible xs-visible">
            <div className="mobile-menu-header">
              <h3>
                <small>
                  <i
                    className="fa fa-times "
                    onClick={this.props.closeNavbar}
                  />
                </small>
                <span className="mobile-menu-header-content">MENU</span>
              </h3>
            </div>
          </div>
          <ul className="nav navbar-nav navbar-right menuItemText">
            <li>
              <Link to="/" onClick={this.props.closeNavbar}>
                Startseite
              </Link>
            </li>
            <li>
              <Link to="/list" onClick={this.props.closeNavbar}>
                Wünsche
              </Link>
            </li>
            <li>
              <Link to="/howto" onClick={this.props.closeNavbar}>
                So geht’s
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={this.props.closeNavbar}>
                Kontakt
              </Link>
            </li>
          </ul>
        </div>
        {!this.props.collapsedNavbar ? (
          <div className="menu-backdrop" onClick={this.props.closeNavbar} />
        ) : null}
      </Swipe>
    );
  }
}

const mapStateToProps = state => {
  return {
    collapsedNavbar: state.navigationReducer.collapsedNavbar
  };
};

const mapDispatchToProps = dispatch => {
  return {
    closeNavbar: () => dispatch(closeNavbar())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Navigation);



// WEBPACK FOOTER //
// ./src/Component/Navigation.js